export function isFirebaseSupported() {
  return "serviceWorker" in navigator && "PushManager" in window;
}
